import { render, staticRenderFns } from "./rightBox.vue?vue&type=template&id=249a8e6b&scoped=true"
import script from "./rightBox.vue?vue&type=script&lang=js"
export * from "./rightBox.vue?vue&type=script&lang=js"
import style0 from "./rightBox.vue?vue&type=style&index=0&id=249a8e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a8e6b",
  null
  
)

export default component.exports